// Copyright (c) 2022 by Move Closer

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export class FormErrors extends Error {
  public name: string = 'Form Errors'

  protected errors: Record<string, string[]> | null = null

  constructor (errors: Record<string, string[]> | null = null) {
    super()

    this.errors = errors
  }

  public get isValid (): boolean {
    return this.errors === null || (Array.isArray(this.errors) && this.errors.length === 0)
  }

  public get payload (): Record<string, string[]> {
    if (!this.errors) {
      return {}
    }

    return this.errors
  }

  /**
   * Gets the errors for given key.
   */
  public getError (key: string): string[] {
    if (!this.errors || !(key in this.errors)) {
      return []
    }

    return this.errors[key]
  }
}
